import { Maybe } from "graphql-tools";

export enum WorklistTools {
  Thaw,
  PoolingNormalization,
  Twelve24TC,
  ExternalThaw,
  Nucleofection,
}

export enum PlatePosition {
  Source = "Source",
  Destination = "Destination",
  Intermediate = "Intermediate",
  Dead = "Dead",
  Nucleofection = "Nucleofection",
  Compound = "Compound",
}

export enum SelectionProcess {
  Stamp,
  RowWise,
  ColWise,
  Pool,
  Random,
}

export enum PoolingNormalizationStep {
  SelectSourceToIntermediate,
  SelectStampMapping,
  SelectIntermediateToDestination,
}

export enum ExternalThawStep {
  SelectSourceToIntermediate,
  SelectIntermediateToDestination,
}

export enum NucleofectionStep {
  SelectSourceAndCompound,
  SelectSourceToNucleofection,
  SelectNucleofectionToIntermediate,
  SelectIntermediateToDestination,
}

export enum DeadTotalCountSpinOrder {
  CountAfterSpin = 0,
  CountBeforeSpin = 1,
}

export enum SelectionType {
  NoSourceWellSelected,
  SelectMultipleSourceAndDestWells,
  SelectMultipleSourceAndOneDestWell,
  SelectOneSourceAndOneDestWell,
  SelectOneSourceAndMultipleDestWells,
}

export interface BasePlateInfo {
  plateBarcode: string;
  labwareTypeCode: string;
}

export interface BaseSrcIntDestPlateInfo extends BasePlateInfo {
  rows: number[];
  cols: number[];
}

export interface WorklistValues {
  sourcePlateIndex: number;
  sourceWellId: string;
  destPlateIndex: number;
  destWellId: string;
  transferVol?: string;
}

export interface ReactSelectableFast {
  props: {
    isSelectable: boolean;
    plateIndex: number;
    platePosition: PlatePosition;
    plateWellId: string;
    sourcePlateInfo?: SourceWellInfo[];
    wellColor?: string;
  };
  node: {
    classList: DOMTokenList;
  };
}

export interface WellSelection {
  plateIndex: number;
  plateWellId: string;
  isSelectable: boolean;
}

export interface SourceWellInfo {
  barcode: string;
  rowPos: number;
  colPos: number;
  sampleId: number;
  sampleBarcode: string;
  color: string;
}

export interface LabwareTypeInfo {
  labwareTypeId?: number;
  labwareTypeCode?: Maybe<string>;
  labwareTypeName?: Maybe<string>;
  labwareTypeSummary?: Maybe<string>;
  labwarePlateType?: Maybe<string>;
  defaultLabwareVolume?: Maybe<number>;
  plateRows?: number[];
  plateCols?: number[];
  defaultArrayPlateCode?: Maybe<string>;
  minLabwareVolume?: Maybe<number>;
  maxLabwareVolume?: Maybe<number>;
}

export interface Worklist {
  task?: string;
  details?: string;
  aspirateVol?: string;
  dispenseVol?: string;
  transferVol?: string;
  sourcePlateType?: string;
  sourcePlateBarcode?: string;
  sourceWellID?: string;
  destinationPlateType?: string;
  destinationPlateBarcode?: string;
  destinationWellID?: string;
}

export interface vSpinSettings {
  vSpinRPM: number;
  vSpinTime: number;
  vSpinAccel: number;
  vSpinDecel: number;
}

export enum SeedingStrategy {
  Volumetric,
  CellCount,
}

export type SplitVolDict = {
  [sourceWellId: string]: {
    numSplits: number;
    volUsed: number;
  };
};

export interface ApplyCellNumOption {
  label: string;
  value: "Apply to All" | "Apply to Empty" | number; //destPlateIndex
}

export const WorklistLastUpdatedDate: Record<WorklistTools, string> = {
  [WorklistTools.Thaw]: "07/28/2021 05:00:00 PM",
  [WorklistTools.PoolingNormalization]: "09/22/2025 05:00:00 PM",
  [WorklistTools.Twelve24TC]: "06/17/2026 05:00:00 PM",
  [WorklistTools.ExternalThaw]: "09/25/2025 05:00:00 PM",
  [WorklistTools.Nucleofection]: "10/16/2025 05:00:00 PM", //No templates for Nucleofection
};
